import { Fragment, useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useHttp from "hooks/use-http";
import Toast from "helper/toast";

import { Grid } from "@mui/material";

import { getcomplaintRequest, deletecomplaintRequest } from "api/requests";

import DrawerCM from "components/shared/Drawer";
import LoadingCM from "components/shared/Loading";
import NotFound from "components/shared/NotFound/NotFound";
import MessageCard from "components/message/complaintCard";
import PaginationCM from "components/shared/Pagination";
import { PAGINATION_LIMIT } from "constants";

import { StyledStack, StyledTitle } from "./Message.style";

export default function Messages() {
  const navigate = useNavigate();
  const { request, loading, setLoading } = useHttp();

  const [page, setPage] = useState(1);
  const [messages, setMessages] = useState({ data: [], count: 0 });

  const onDelete = async (id) => {
    const res = await request({
      url: deletecomplaintRequest, 
      values: id,
    });
    if (res) {
      Toast({ type: "success", title: "حذف شکایت " });
      getMessageInfo();
    }
  };

  const getMessageInfo = useCallback(async () => {
    setLoading(true);
    const res = await request({
      url: getcomplaintRequest,
      values: {
        skip: (page - 1) * PAGINATION_LIMIT,
        limit: PAGINATION_LIMIT,
      },
    });
    setLoading(false);
    if (res) {
      let transformedData = res.data.map((items) => ({
        id: items.id,
        full_name: items.full_name,
        subject: items.subject,
        phone_number: items.phone_number,
        is_seen: items.is_seen,
      }));
      setMessages({
        data: transformedData,
        count: res.count,
      });
    }
  }, [page, request]);

  useEffect(() => {
    getMessageInfo();
  }, [page, getMessageInfo]);

  return (
    <DrawerCM title="شکایات کاربران">
      {loading ? (
        <LoadingCM />
      ) : messages.count < 1 ? (
        <NotFound title={"هیچ اطلاعاتی یافت نشد"} />
      ) : (
        <Fragment>
          <StyledStack>
            <StyledTitle>شکایت های دریافتی</StyledTitle>
            <Grid
              container
              spacing={0}
              justifyContent="center"
              alignItems="center"
            >
              {messages.count < 1
                ? "هیچ اطلاعاتی یافت نشد"
                : messages.data.map((item, index) => (
                    <Grid item md={12} xs={12} p={1} key={index}>
                      <MessageCard
                        index={index}
                        item={item}
                        click={() => navigate("/complaint/" + item.id)}
                        delete={onDelete}
                      />
                    </Grid>
                  ))}
            </Grid>
          </StyledStack>
          <Grid
            container
            spacing={0}
            alignItems="center"
            justifyContent="center"
          >
            {messages.data.length < 1 ? (
              ""
            ) : (
              <PaginationCM
                handleChange={(e, val) => setPage(val)}
                page={page}
                count={messages.count}
              />
            )}
          </Grid>
        </Fragment>
      )}
    </DrawerCM>
  );
}
